import App from "./components/App";
import ReactDOM from "react-dom";
import "../src/common/css/reset.scss";
import "../src/common/css/style.scss";

ReactDOM.render(<App />, document.querySelector(".root"));
